import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const UPDATE_USER_MUTATION = gql`
	mutation($userID: ID!, $data: JSON!) {
		updateUser(userID: $userID, data: $data) {
			id
			username
			password
			firstName
			lastName
			roles
		}
	}
`;

export default ({ children }) => (
	<Mutation mutation={UPDATE_USER_MUTATION} refetchQueries={['adminQuery']}>
		{updateUser => Propagator(children, updateUser)}
	</Mutation>
);
